import Store from '@/store';
import vuetify from '@/plugins/vuetify';

const theme = vuetify.framework.theme;
let isClick = true;
let processViewArr = [];
function findIndexItem(arrView, arr, col = 'id') {
  const index = arr.findIndex(
    (row) => row.item[col] === arrView.item[col] && row.type === arrView.type,
  );
  return index > -1 ? index : null;
}

export function openWindow(config) {
  const { arrView, url, params, queryParams, size, onMessage, onClose } = config;

  const id = arrView.item.id.toString();
  const type = arrView.type;
  const index = findIndexItem(arrView, processViewArr, 'id');
  if (index != null) {
    window.layoutFocus[type + id]();
    return;
  }

  if (!isClick) {
    return;
  }
  isClick = false;
  let querystring = 'popup=true&';
  if (theme.isDark == true) {
    querystring += 'theme=Dark';
  } else {
    querystring += 'theme=Light';
  }
  if (queryParams) {
    querystring += queryParams;
  }

  Store.commit('analysis/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, params));

  const win = window.open(`${url}?${querystring}`, '_blank', size || '');
  if (!win) {
    isClick = true;
    return;
  }
  win.opener = null;
  win.params = params;
  win.newWindowExpire = true;
  let isClosed = false;

  function handleClose() {
    if (isClosed) return;
    isClosed = true;
    isClick = true;
    const index = findIndexItem(arrView, processViewArr, 'id');
    if (index != null) {
      processViewArr.splice(index, 1);
    }
    Store.commit('analysis/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, params));

    onClose?.();

    clearInterval(checkWindow);
  }
  let checkWindow = setInterval(() => {
    if (win.closed) {
      handleClose();
    }
  }, 200);

  win.addEventListener('load', () => {
    processViewArr.push(arrView);
    isClick = true;
  });

  win.addEventListener('message', (data) => {
    const message = data.data.message;
    if (message) {
      onMessage?.(message);
      if (message === 'btn-close') {
        handleClose();
        win.close();
      }
    }
  });

  win.focusPopup = () => win.focus();
  win.theme = false;
  if (theme.isDark == true) {
    win.theme = theme.isDark;
  }
  if (typeof window.processOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
    window.processOpenWindow = {
      [type + id]: win.closePopup,
    };
    window.layoutFocus = { [type + id]: win.focusPopup };
  } else {
    window.processOpenWindow[type + id] = win.closePopup;
    window.layoutFocus[type + id] = win.focusPopup;
  }
}
